// extracted by mini-css-extract-plugin
module.exports = {"tduInfo":"TduInfo_tduInfo__2Vk-L","tduCode":"TduInfo_tduCode__WHJ-p"};